import * as React from 'react';

import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { fieldBase, fieldSizes, fieldVariants } from './lib';

const inputVariants = cva(fieldBase, {
  variants: {
    variant: fieldVariants,
    inputSize: fieldSizes,
  },
  defaultVariants: {
    variant: 'dark',
    inputSize: 'default',
  },
});

export interface InputProps
  extends
    React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, inputSize, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant, inputSize, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
